<template>
    <main class="min-h-screen w-full">
        <div
            class="active-edit:right-96 fixed top-14 right-0 bottom-0 left-0 z-19 overflow-x-auto overflow-y-auto py-10 text-left lg:left-64"
        >
            <div
                v-if="stateRepository.states.wideEditorActive === true"
                class="flex justify-center"
            >
                <div
                    class="relative mx-auto aspect-[1280/1935] w-full max-w-[800px] bg-[url('/theme/default/tablet-frame.png')] bg-contain bg-center bg-no-repeat"
                >
                    <button
                        v-show="activeComponents.content.id === 'xxxxx'"
                        type="button"
                        class="absolute top-[4%] right-[5%] rounded-full bg-white text-red-400 hover:text-gray-500 focus:outline-hidden"
                        @click="riseFakeEditor(false)"
                    >
                        <span class="sr-only">Close editor</span>
                        <MdiClose
                            class="h-5 w-5"
                            aria-hidden="true"
                        />
                    </button>
                    <div class="absolute top-[10%] right-[5%] bottom-[11%] left-[5%]">
                        <textarea
                            id="sms-editor"
                            v-model="templateVersionModel.source"
                            name="sms"
                            class="h-full w-full resize-none border-gray-300 text-base shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                            placeholder="Text sms"
                            @focus="riseFakeEditor()"
                        ></textarea>
                    </div>
                </div>
            </div>
            <div
                v-if="stateRepository.states.wideEditorActive === false"
                class="flex justify-center"
            >
                <div
                    class="template-base template-base-sms relative mx-auto inline-block w-80 bg-cover p-4 pt-16 pb-20"
                    style="background-image: url(/theme/default/m-frame-w.png)"
                >
                    <button
                        v-show="activeComponents.content.id === 'xxxxx'"
                        type="button"
                        class="absolute top-4 right-4 rounded-full bg-white text-red-400 hover:text-gray-500 focus:outline-hidden"
                        @click="riseFakeEditor(false)"
                    >
                        <span class="sr-only">Close editor</span>
                        <MdiClose
                            class="h-5 w-5"
                            aria-hidden="true"
                        />
                    </button>
                    <textarea
                        id="sms-editor"
                        v-model="templateVersionModel.source"
                        name="sms"
                        rows="20"
                        class="mt-1 block w-full resize-none rounded-md border-gray-300 text-base shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                        placeholder="Text sms"
                        @focus="riseFakeEditor()"
                    >
                    </textarea>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup>
    import { MdiClose } from 'materialdesignicons-vue3/icons';

    const props = defineProps({
        templateVersionModel: {
            type: Object,
            required: true,
        },
        activeComponents: {
            type: Object,
            required: true,
        },
        stateRepository: {
            type: Object,
            required: true,
        },
    });

    const templateVersionModel = props.templateVersionModel;
    const activeComponents = props.activeComponents;
    const stateRepository = props.stateRepository;

    const riseFakeEditor = (active = true) => {
        activeComponents.content.id = active ? 'xxxxx' : '';
        activeComponents.editor.active = active;
    };
</script>
